export class requestXLSBudget {

    dealerGroupId:string;
    year:number;
    month:number;
    budget:string;
    dealerships:string;
    constructor (data) {
        this.dealerGroupId = data.dealerGroupId;
        this.year = data.year;
        this.month = data.month;
        this.budget = data.budget;
        this.dealerships = data.dealerships;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/class/http/req/request-xls-budget.ts